import { __decorate } from "tslib";
import Vue from 'vue';
import Component from "vue-class-component";
let Snackbar = class Snackbar extends Vue {
    snackbar = false;
    defaultMessage = '';
    defaultColor = 'black';
    defaultIcon = '';
    defaultTimeout = 3000;
    message = this.defaultMessage;
    color = this.defaultColor;
    icon = this.defaultIcon;
    timeout = this.defaultTimeout;
    open(message, icon = this.defaultIcon, color = this.defaultColor, timeout = this.defaultTimeout) {
        this.message = message;
        this.icon = icon;
        this.color = color;
        this.timeout = timeout;
        this.snackbar = true;
        setTimeout(() => {
            this.message = this.defaultMessage;
            this.color = this.defaultColor;
            this.icon = this.defaultIcon;
            this.timeout = this.defaultTimeout;
        }, this.timeout + 500);
    }
    openSnack(event) {
        this.open(event.detail.message, event.detail.icon, event.detail.color, event.detail.timeout);
    }
    openInfo(event) {
        this.open(event.detail.message, 'mdi-information', 'blue');
    }
    openSuccess(event) {
        this.open(event.detail.message, 'mdi-check-circle', 'green');
    }
    openWarning(event) {
        this.open(event.detail.message, 'mdi-alert-circle', 'orange');
    }
    openError(event) {
        this.open(event.detail.message, 'mdi-close-circle-outline', 'red');
    }
    static snack(message, icon = '', color = 'black', timeout = 3000) {
        document.dispatchEvent(new CustomEvent('snack', {
            detail: { message, icon, color, timeout },
        }));
    }
    static info(message) {
        document.dispatchEvent(new CustomEvent('snackInfo', {
            detail: { message },
        }));
    }
    static success(message) {
        document.dispatchEvent(new CustomEvent('snackSuccess', {
            detail: { message },
        }));
    }
    static warning(message) {
        document.dispatchEvent(new CustomEvent('snackWarning', {
            detail: { message },
        }));
    }
    static error(message) {
        document.dispatchEvent(new CustomEvent('snackError', {
            detail: { message },
        }));
    }
    created() {
        document.addEventListener('snack', this.openSnack);
        document.addEventListener('snackInfo', this.openInfo);
        document.addEventListener('snackSuccess', this.openSuccess);
        document.addEventListener('snackWarning', this.openWarning);
        document.addEventListener('snackError', this.openError);
    }
    beforeDestroy() {
        document.removeEventListener('snack', this.openSnack);
        document.removeEventListener('snackInfo', this.openInfo);
        document.removeEventListener('snackSuccess', this.openSuccess);
        document.removeEventListener('snackWarning', this.openWarning);
        document.removeEventListener('snackError', this.openError);
    }
};
Snackbar = __decorate([
    Component
], Snackbar);
export default Snackbar;
